module.exports = __webpack_public_path__ + "static/og-image-bdf0af873c13e8a622e4b26f0fefc430.jpg";